import { PipeTransform, Pipe } from "@angular/core";
import * as moment from 'moment';

@Pipe({
  name: 'localDateTimePipe2'
})
export class LocalDateTimePipe2 implements PipeTransform{
  transform(date: string): string {
    let dateOut: moment.Moment = moment(date, "YYYY-MM-DD");
    return dateOut.format("DD/MM/YYYY");
}
}



// WEBPACK FOOTER //
// /app/src/app/components/caixa/pesquisa-caixa-avancada/local-date.ts